import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { CsrfService } from '../services';

export const csrfInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const csrfService = inject(CsrfService);
  const protectedMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];

  let clonedReq = req.clone({ withCredentials: true });

  if (!protectedMethods.includes(req.method.toUpperCase())) {
    return next(clonedReq);
  }

  const token = csrfService.getToken();

  if (token) {
    clonedReq = clonedReq.clone({
      headers: clonedReq.headers.set('X-CSRF-TOKEN', token),
    });
  } else {
    console.warn(
      'Petición enviada sin CSRF token. Es posible que el servidor la rechace si el refresh no ha terminado.',
    );
  }

  return next(clonedReq);
};
